import { api } from "./api";

export const ZonaService = {

  async findAll() {
    const response = await api.get("/zonas");

    console.log("ZonaService.findAll response:", response);
    return response.data;
  },

  async findById(id: number) {
    const response = await api.get(`/zonas/${id}`);
    return response.data;
  },

  async create(data: any) {
    const response = await api.post("/zonas", data);
    return response.data;
  },

  async update(id: number, data: any) {
    const response = await api.put(`/zonas/${id}`, data);
    return response.data;
  },

  async delete(id: number) {
    const response = await api.delete(`/zonas/${id}`);
    return response.data;
  }
};